import React from 'react';
import { Avatar } from '@mui/material';

const stringToColor = (string) => {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colors = ['#1976d2', '#2196f3', '#0288d1', '#0277bd', '#01579b'];
  return colors[Math.abs(hash) % colors.length];
};

const getInitials = (name) => {
  if (!name) return 'U';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

const UserAvatar = ({ user, size = 40, sx = {} }) => {
  const name = user?.name || '';
  const profilePicture = user?.profile_picture;
  const initials = getInitials(name);
  const textColor = stringToColor(name || 'User');
  const [imageError, setImageError] = React.useState(false);

  if (profilePicture && !imageError) {
    return (
      <Avatar
        src={profilePicture}
        alt={name}
        onError={() => setImageError(true)}
        sx={{
          width: size,
          height: size,
          ...sx
        }}
      >
        {initials}
      </Avatar>
    );
  }

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: '#e3f2fd',
        color: textColor,
        fontSize: size * 0.4,
        fontWeight: 600,
        ...sx
      }}
    >
      {initials}
    </Avatar>
  );
};

export default UserAvatar;
